/* =====================================================================
   cw-cart.js, Chrome Watches cart + free-gift behaviour.
   Extracted from sections/cw-header.liquid to keep that section under
   Shopify's 256KB template limit. Liquid values arrive via the global
   window.CWCartConfig (set inline in the header before this loads).

   Preserves the optimized flow: optimistic drawer open, ONE bundled
   /cart/add.js (watch + missing gifts) and ONE bundled /cart/update.js
   (remove + gift cleanup) with Section Rendering in the same response,
   no /cart.js and no full-page fetch on normal add/remove.
   ?cwperf=1 timing instrumentation lives here too.
   ===================================================================== */
  /* ===== CW-CART-PERF-DEBUG =================================================
     Temporary Add-to-Cart timing instrumentation. Disabled by default.
     Enable on mobile/desktop by either:
       - adding ?cwperf=1 to the URL, or
       - running localStorage.setItem('cw_cart_perf','1') in the console.
     Reads as a labelled, indented timeline in the console.
     TO REMOVE: delete this entire <script> block and the CWPerf.* calls
     (search the theme for "CWPerf" / "CW-CART-PERF-DEBUG").
     ========================================================================= */
  window.CWPerf = (function () {
    var enabled = false;
    try {
      enabled = /[?&]cwperf=1/.test(location.search) || localStorage.getItem('cw_cart_perf') === '1';
    } catch (e) {}
    function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    var t0 = 0, last = 0, reqs = [], flags = {};
    function pad(s) { s = String(s); return s + new Array(Math.max(1, 28 - s.length)).join(' '); }
    return {
      enabled: enabled,
      start: function (label) {
        if (!enabled) return;
        t0 = last = now(); reqs = []; flags = {};
        console.log('%c[CWPerf] ▶ ' + (label || 'click'), 'color:#e02020;font-weight:bold');
      },
      mark: function (label) {
        if (!enabled || !t0) return;
        var t = now();
        console.log('[CWPerf]   ' + pad(label) + '  +' + (t - last).toFixed(1) + 'ms   (T=' + (t - t0).toFixed(1) + 'ms)');
        last = t;
      },
      /* Record a cart network request (name + start time); returns a done()
         to call when it resolves so we can log its duration. */
      net: function (name) {
        if (!enabled || !t0) return function () {};
        var startedAt = now(), idx = reqs.length;
        reqs.push(name);
        console.log('[CWPerf]   → request #' + (idx + 1) + ': ' + name);
        return function () {
          console.log('[CWPerf]     ✓ ' + name + ' (' + (now() - startedAt).toFixed(1) + 'ms)');
        };
      },
      flag: function (key, val) {
        if (!enabled) return;
        flags[key] = val;
      },
      end: function (label) {
        if (!enabled || !t0) return;
        var t = now();
        console.log('[CWPerf]   ' + pad(label || 'visible') + '  +' + (t - last).toFixed(1) + 'ms   (T=' + (t - t0).toFixed(1) + 'ms)');
        console.log('%c[CWPerf] ■ total click→final drawer: ' + (t - t0).toFixed(1) + 'ms', 'color:#0a7d00;font-weight:bold');
        console.log('%c[CWPerf] ■ cart requests: ' + reqs.length + ' [' + reqs.join(', ') + ']', 'color:#0a7d00;font-weight:bold');
        console.log('[CWPerf]   flags: ' + JSON.stringify(flags));
        t0 = 0;
      }
    };
  })();
  /* ===== /CW-CART-PERF-DEBUG =============================================== */

  /* FINAL CLEAN CART CONTROLLER:
     - no auto-open on product pages
     - X close works after drawer refresh
     - gifts add once only and stay qty 1
     - gift toast shows only when gifts are newly added
     - cart updates without page refresh */
  (function() {
    if (window.CWFinalCartControllerReady) return;
    window.CWFinalCartControllerReady = true;

    var CWPerf = window.CWPerf || { mark: function () {}, start: function () {}, end: function () {} };
    /* This section's id, used for the Section Rendering API so the cart drawer
       refresh fetches ONLY this section instead of the whole product page. */
    var headerSectionId = window.CWCartConfig.sectionId;

    var watchCaseVariantId = window.CWCartConfig.giftVariantIds.watchCase;
    var adjustmentKitVariantId = window.CWCartConfig.giftVariantIds.adjustmentKit;
    var bonusGiftVariantId = window.CWCartConfig.giftVariantIds.bonus;
    var mysteryGiftVariantId = window.CWCartConfig.giftVariantIds.mystery;
    var legacyRubberGiftVariantId = window.CWCartConfig.giftVariantIds.legacyRubber;
    var legacyBonusGiftVariantId = window.CWCartConfig.giftVariantIds.legacyBonus;
    var giftVariantIds = [watchCaseVariantId, adjustmentKitVariantId, bonusGiftVariantId, mysteryGiftVariantId, legacyRubberGiftVariantId, legacyBonusGiftVariantId].filter(Boolean).map(String);
    var removedGiftKey = 'cw_removed_free_gifts_final';
    var syncing = false;
    var refreshing = false;
    var cleaningEngravings = false;
    var cartMutating = false;

    /* Replays the staggered item-entrance animation (CSS: .is-entering rules in
       cw-header.liquid). Called when the drawer transitions closed→open and when
       fresh content replaces the loading skeleton. The class self-clears after
       the longest stagger delay so a later reopen can replay it. */
    var enterCascadeTimer = null;
    function restartEnterCascade() {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-entering');
      void drawer.offsetWidth; /* reflow so re-adding the class restarts the animations */
      drawer.classList.add('is-entering');
      if (enterCascadeTimer) window.clearTimeout(enterCascadeTimer);
      enterCascadeTimer = window.setTimeout(function() {
        var d = document.querySelector('[data-cw-cart-drawer]');
        if (d) d.classList.remove('is-entering');
      }, 950);
    }

    function openCart() {
      /* Dismiss any focused field (mobile keyboard) before the drawer opens so the
         page returns to 100% scale and the cart isn't left zoomed in. */
      var activeEl = document.activeElement;
      if (activeEl && /^(INPUT|TEXTAREA|SELECT)$/.test(activeEl.tagName)) {
        activeEl.blur();
      }
      var wasOpen = document.body.classList.contains('cw-cart-open');
      if (typeof window.CWAllowCartOpenForCurrentInteraction === 'function') {
        window.CWAllowCartOpenForCurrentInteraction();
      } else {
        window.__CW_CART_INTERACTION_ACTIVE__ = true;
      }
      document.body.classList.add('cw-cart-open');
      if (!wasOpen) scheduleProtectionCheck();
      /* Only cascade on a genuine closed→open transition, not on the keep-open
         calls that follow every drawer refresh. */
      if (!wasOpen) restartEnterCascade();
    }

    function closeCart() {
      closeSheet();
      window.__CW_CART_INTERACTION_ACTIVE__ = false;
      document.body.classList.remove('cw-cart-open');
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (drawer) drawer.classList.remove('is-entering');
    }

    /* Open the drawer immediately in a loading state (optimistic), before any
       network call completes. Decouples "drawer is visible" from the cart/add +
       gift-sync + refresh chain so feedback is instant and the slide animation
       plays from the painted closed state. Content fills in when refresh lands. */
    function openCartLoading() {
      openCart();
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (drawer) {
        drawer.classList.add('is-updating');
        /* The skeleton overlay anchors to the top of the list, make sure the
           list is actually at the top so they line up. */
        var body = drawer.querySelector('.cw-cart-drawer__body');
        if (body) body.scrollTop = 0;
      }
    }
    window.CWOpenCartLoading = openCartLoading;

    /* Collapse a line item that is being removed: freeze its current height,
       then transition height/padding to zero while it fades and slides out
       (CSS: .cw-cart-item--removing). Runs while the remove request is in
       flight, so by the time the drawer content refreshes the row is already
       gone visually. Inline styles use the 'important' priority because later
       polish blocks set the item padding with !important. */
    function startRemoveCollapse(el) {
      if (!el || el.classList.contains('cw-cart-item--removing')) return;
      el.style.setProperty('height', el.offsetHeight + 'px', 'important');
      el.classList.add('cw-cart-item--removing');
      void el.offsetHeight; /* commit the start height so the collapse transitions */
      el.style.setProperty('height', '0px', 'important');
      el.style.setProperty('padding-top', '0px', 'important');
      el.style.setProperty('padding-bottom', '0px', 'important');
    }

    /* Restore a collapsed row (the remove request failed, e.g. rate-limited). */
    function undoRemoveCollapse(el) {
      if (!el) return;
      el.classList.remove('cw-cart-item--removing');
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
    }

    /* Always clears the loading skeleton. Called on success (after the refresh
       swaps the drawer) and on failure, so the drawer can never get stuck
       loading forever. Safe to call any number of times. Also restores any
       mid-collapse rows so a failed remove never leaves a hidden-but-present
       line item. */
    function stopCartLoading() {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (drawer) drawer.classList.remove('is-updating');
      Array.prototype.forEach.call(document.querySelectorAll('.cw-cart-item--loading'), function(el) {
        el.classList.remove('cw-cart-item--loading');
      });
      Array.prototype.forEach.call(document.querySelectorAll('.cw-cart-item--removing'), undoRemoveCollapse);
    }
    window.CWStopCartLoading = stopCartLoading;

    /* Hard failure (e.g. /cart/add.js failed and nothing was added): clear the
       spinner and undo the optimistic open so the drawer never sits blank. */
    function failCartLoading() {
      stopCartLoading();
      closeCart();
    }
    window.CWFailCartLoading = failCartLoading;

    /* Gifts can no longer be removed by the shopper (October 2, 2026): every watch
       ships with its gifts. The old "removed gift" memory lived in the browser tab
       and kept gifts off the cart even after a watch swap or a reload, which sent
       orders #1377 and #1378 out without gifts. Always empty now, and any memory
       left in an open tab is cleared so that cart repairs itself on the next sync. */
    function getRemovedGifts() {
      try { sessionStorage.removeItem(removedGiftKey); } catch (e) {}
      return [];
    }

    function resetRemovedGiftsIfNoWatch(watchCount) {
      if (watchCount === 0) {
        try { sessionStorage.removeItem(removedGiftKey); } catch (e) {}
      }
    }

    function isGiftItem(item) {
      var props = item.properties || {};
      return giftVariantIds.indexOf(String(item.variant_id || '')) !== -1 || props._free_gift === 'true';
    }

    function isWatchItem(item) {
      var props = item.properties || {};
      var title = String(item.product_title || item.title || '').toLowerCase();
      var handle = String(item.handle || item.product_handle || '').toLowerCase();
      return !isGiftItem(item) && (
        !!props._Configurator ||
        title.indexOf('seiko mod') !== -1 ||
        title.indexOf('seiko') !== -1 ||
        handle.indexOf('seiko') !== -1
      );
    }

    /* Compact, PII-free summary of an outgoing cart payload for debug logs:
       variant ids, quantities, property KEYS (not values), updates map, and the
       requested sections param. No engraving text or customer data. */
    function summarizePayload(body) {
      if (!body || typeof body !== 'object') return null;
      var s = {};
      if (body.items) {
        s.items = body.items.map(function(it) {
          return { id: it.id, quantity: it.quantity, propKeys: it.properties ? Object.keys(it.properties) : [] };
        });
      }
      if (body.updates) s.updates = body.updates;
      if (body.sections) s.sections = body.sections;
      return s;
    }

    /* Resilient cart-response parser. Reads the body as text ONCE, only
       JSON-parses when the body is actually JSON, converts rate limits / HTTP
       errors into clean tagged Errors (never a raw "Unexpected token '<'"), and
       - crucially, treats a 2xx response with an UNPARSEABLE body as success
       (the mutation happened; we just can't read the bundled body), so callers
       refresh the drawer instead of alerting a hard failure.
       Pass ctx = { method, label, sent } for rich ?cwperf=1 diagnostics. */
    function parseCartResponse(response, ctx) {
      ctx = ctx || {};
      return response.text().then(function(text) {
        var ctype = (response.headers.get('content-type') || '').toLowerCase();
        var isJson = ctype.indexOf('json') !== -1;
        var data = null;
        // Shopify can label valid JSON as text/javascript. Parse the body rather
        // than discarding a successful bundled response based on its MIME type.
        try { data = JSON.parse(text); } catch (e) { data = null; }

        function debug(kind) {
          if (!CWPerf.enabled) return;
          var msg = (data && (data.description || data.message)) || '';
          console.warn('[CW Cart Error] ' + (ctx.method || 'GET') + ' ' + (ctx.label || response.url)
            + ' status=' + response.status + ' contentType=' + (ctype || 'none')
            + ' kind=' + kind + (msg ? ' message="' + msg + '"' : ''));
          if (!isJson || data === null) console.warn('[CW Cart Error] body preview:', (text || '').slice(0, 200));
          if (ctx.sent) console.warn('[CW Cart Error] sent:', ctx.sent);
        }

        if (response.status === 429) {
          debug('rate-limited');
          var rl = new Error(cwT('Cart is updating too quickly. Please wait a moment and try again.'));
          rl.code = 'RATE_LIMITED';
          throw rl;
        }
        if (!response.ok) {
          debug('http-error');
          var ce = new Error((data && (data.description || data.message)) || cwT('Unable to update your cart.'));
          ce.code = 'CART_ERROR';
          ce.status = response.status;
          throw ce;
        }
        if (data === null) {
          /* 2xx but body not parseable JSON (commonly seen under
             `shopify theme dev`, whose local proxy can hand back an empty/HTML
             body for a cart mutation that actually succeeded). Don't fail, 
             signal success-without-body so the caller refreshes the drawer. */
          debug('ok-unparseable');
          return { __unparsed: true, status: response.status };
        }
        return data;
      });
    }

    function notifyCartError(error) {
      window.alert((error && error.message) || cwT('Unable to update your cart. Please try again.'));
    }

    function fetchCart() {
      return fetch(window.CWCartConfig.routes.cart, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function(response) {
        return parseCartResponse(response, { method: 'GET', label: '/cart.js' });
      }).then(function(data) {
        /* A cart READ we can't parse must NOT be treated as an empty cart (that
           would wrongly strip gifts), surface it so callers no-op safely. */
        if (data && data.__unparsed) { var e = new Error('Cart read returned no usable body'); e.code = 'UNPARSEABLE'; throw e; }
        return data;
      });
    }

    function addVariant(variantId, properties, quantity) {
      return fetch(window.CWCartConfig.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Math.max(1, Number(quantity) || 1),
          properties: properties || {}
        })
      }).then(parseCartResponse);
    }

    function changeLine(line, quantity) {
      return fetch(window.CWCartConfig.routes.cartChange, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        })
      }).then(parseCartResponse);
    }

    function changeByKey(key, quantity) {
      return fetch(window.CWCartConfig.routes.cartChange, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: Number(quantity)
        })
      }).then(parseCartResponse);
    }

    /* Slide/fade the toast out, then mark it hidden after the transition so the
       exit animation can play (don't set [hidden] immediately, which would kill
       the transition). */
    function hideGiftToastEl(toast) {
      if (!toast) return;
      toast.classList.remove('is-active');
      if (toast.__cwHideTimer) window.clearTimeout(toast.__cwHideTimer);
      toast.__cwHideTimer = window.setTimeout(function() { toast.hidden = true; }, 320);
    }
    window.CWHideGiftToast = hideGiftToastEl;

    /* Show the gift toast. Single shared node (no duplicates); re-show resets the
       auto-dismiss timer. Auto-dismisses at ~2.8s with a smooth slide/fade out. */
    function showGiftToast(type) {
      var selector = type === 'bonus' ? '[data-cw-bonus-gift-toast]' : '[data-cw-free-gift-toast]';
      var toast = document.querySelector(selector);
      if (!toast) return;

      if (toast.__cwHideTimer) { window.clearTimeout(toast.__cwHideTimer); toast.__cwHideTimer = null; }
      toast.hidden = false;
      void toast.offsetWidth; /* reflow so the enter transition replays on re-show */
      toast.classList.add('is-active');

      var timerName = type === 'bonus' ? 'CWBonusGiftToastTimer' : 'CWGiftToastTimer';
      window.clearTimeout(window[timerName]);
      window[timerName] = window.setTimeout(function() {
        hideGiftToastEl(toast);
      }, 2500);
    }

    /* An engraving ADD-ON line, NOT the watch. Only engraving add-ons carry the
       _Engraving Type property; the watch carries _Engraving Group ID too, so we
       must NOT key off that here, or the watch would be mistaken for an engraving
       and every engraving would look "orphaned" even with its watch present. */
    function isEngravingAddonItem(item) {
      var props = item.properties || {};
      if (props['_Engraving Type'] || props['_Addon Type']) return true;
      var title = String(item.product_title || item.title || '').toLowerCase();
      return title.indexOf('custom rotor engraving') !== -1
          || title.indexOf('custom crown engraving') !== -1
          || title.indexOf('custom caseback engraving') !== -1
          || title.indexOf('custom clasp engraving') !== -1
          || title.indexOf('custom dial logo') !== -1;
    }

    /* An add-on PRODUCT line (pre-sizing, 10 ATM, warranty, shipping protection,
       engraving) by product type. Oct 15, 2026: a shopper reached the add-on
       product page from /collections/all and checked out "Bracelet Pre-Sizing"
       alone. Such a line has no group id, so it needs its own orphan rule: no
       watch in the cart means the add-on goes. Checkout also refuses it
       server-side (Shopify Function addon-needs-watch). */
    function isAddonProductItem(item) {
      var type = String((item && item.product_type) || '').toLowerCase();
      return type.indexOf('add-on') !== -1;
    }
    function cartHasWatch(items) {
      return (items || []).some(function(item) {
        return !isEngravingAddonItem(item) && !isAddonProductItem(item) && isWatchItem(item);
      });
    }

    /* Group id that links a watch and its add-on lines. Engraving lines use
       _Engraving Group ID; add-ons ticked under Add to cart (Oct 6, 2026) use
       _Addon Group ID. A watch with both carries the same id in both. */
    function linkGroupId(props) {
      props = props || {};
      return props['_Addon Group ID'] || props['_Engraving Group ID'] || '';
    }

    /* Remove engraving add-ons whose linked watch is no longer in the cart.
       Preferred match: shared private _Engraving Group ID. Fallback: _Linked Watch title. */
    function removeOrphanedEngravings() {
      if (cleaningEngravings) return Promise.resolve({ changed: false });
      cleaningEngravings = true;

      return fetchCart()
        .then(function(cart) {
          var items = (cart && cart.items) || [];
          var presentGroupIds = {};
          var presentWatchTitles = {};

          items.forEach(function(item) {
            if (isEngravingAddonItem(item)) return;
            var props = item.properties || {};
            if (props['_Engraving Group ID']) presentGroupIds[String(props['_Engraving Group ID'])] = true;
            if (props['_Addon Group ID']) presentGroupIds[String(props['_Addon Group ID'])] = true;
            var title = String(item.product_title || item.title || '');
            if (title) presentWatchTitles[title] = true;
          });

          var chain = Promise.resolve();
          var changed = false;
          var hasWatch = cartHasWatch(items);

          items.forEach(function(item) {
            var addonProduct = isAddonProductItem(item);
            if (!isEngravingAddonItem(item) && !addonProduct) return;
            var props = item.properties || {};
            var gid = linkGroupId(props);
            var orphan = false;

            if (addonProduct && !hasWatch) {
              orphan = true;
            } else if (gid) {
              orphan = !presentGroupIds[String(gid)];
            } else {
              var linked = String(props['_Linked Watch'] || '');
              orphan = linked !== '' && !presentWatchTitles[linked];
            }

            if (orphan) {
              changed = true;
              chain = chain.then(function() { return changeByKey(item.key, 0); });
            }
          });

          return chain.then(function() { return { changed: changed }; });
        })
        .catch(function() { return { changed: false }; })
        .finally(function() {
          cleaningEngravings = false;
        });
    }

    function syncGifts(cartSnapshot, keepOpen) {
      if (syncing) return Promise.resolve({ changed: false });
      syncing = true;
      CWPerf.mark('syncGifts:start');

      return (cartSnapshot && cartSnapshot.items ? Promise.resolve(cartSnapshot) : fetchCart())
        .then(function(cart) {
          var watchCount = 0;
          var removed = getRemovedGifts();
          cart.items.forEach(function(item) {
            if (isWatchItem(item)) {
              watchCount += Number(item.quantity || 0);
            }
          });
          resetRemovedGiftsIfNoWatch(watchCount);
          var requiredQuantities = requiredGiftQuantities(watchCount);
          var seen = {};
          var changed = false;
          /* Shopify may split a line when a discount changes, and line keys
             change with it. An array update targets the current cart's exact
             line order, so all gift removals and quantity fixes are atomic. */
          var updates = cart.items.map(function(item) {
            var quantity = Number(item.quantity || 0);
            if (!isGiftItem(item)) return quantity;
            var id = String(item.variant_id);
            if (!requiredQuantities[id]) {
              if (quantity !== 0) changed = true;
              return 0;
            }
            if (removed.indexOf(id) !== -1) return quantity;
            if (seen[id]) {
              if (quantity !== 0) changed = true;
              return 0;
            }
            seen[id] = true;
            if (quantity !== requiredQuantities[id]) changed = true;
            return requiredQuantities[id];
          });
          var update = changed
            ? postCartJson(window.CWCartConfig.routes.cartUpdate, { updates: updates, sections: headerSectionId, sections_url: sectionsUrl() }, '/cart/update.js (gift repair)')
            : Promise.resolve(cart);
          return update.then(function(updatedCart) {

            return updatedCart && updatedCart.items ? updatedCart : fetchCart();
          }).then(function(currentCart) {
            var present = {};
            currentCart.items.forEach(function(item) {
              if (isGiftItem(item)) present[String(item.variant_id)] = true;
            });
            var missing = Object.keys(requiredQuantities).filter(function(id) {
              return !present[id] && removed.indexOf(id) === -1;
            });
            if (!missing.length) return { changed: changed, giftToastType: null, rendered: applyDrawerFromSections(currentCart.sections, keepOpen !== false, null) };
            return postCartJson(window.CWCartConfig.routes.cartAdd, {
              sections: headerSectionId, sections_url: sectionsUrl(),
              items: missing.map(function(id) {
                return { id: Number(id), quantity: requiredQuantities[id], properties: { _free_gift: 'true' } };
              })
            }, '/cart/add.js (missing gifts)').then(function(data) {
              return { changed: true, giftToastType: 'standard', rendered: applyDrawerFromSections(data && data.sections, keepOpen !== false, 'standard') };
            });
          });
        })
        .finally(function() {
          syncing = false;
          setCartBusy(cartMutating);
          CWPerf.mark('syncGifts:done');
        });
    }

    function initOfferCarousel() {
      var root = document.querySelector('[data-cw-cart-offers]');
      if (!root) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cw-offer-slide]')).slice(0, 5);
      var dotsRoot = root.querySelector('[data-cw-offer-dots]');
      if (!dotsRoot) return;

      if (!slides.length) {
        root.style.display = 'none';
        return;
      }

      dotsRoot.innerHTML = '';

      slides.forEach(function(slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cw-cart-offers__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', cwT('Show offer {n}', {n: index + 1}));

        dot.addEventListener('click', function() {
          slides.forEach(function(item, itemIndex) {
            item.classList.toggle('is-active', itemIndex === index);
          });
          Array.prototype.slice.call(dotsRoot.children).forEach(function(item, itemIndex) {
            item.classList.toggle('is-active', itemIndex === index);
          });
        });

        dotsRoot.appendChild(dot);
        slide.classList.toggle('is-active', index === 0);
      });
    }

    function initPairCarousel() {
      var track = document.querySelector('.cw-cart-pair__track');
      if (!track || track.dataset.ready === 'true') return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-cw-pair-card]'));
      if (!cards.length) return;
      var frame = 0;
      function updateCurrent() {
        frame = 0;
        var trackLeft = track.getBoundingClientRect().left;
        var current = cards[0];
        var nearest = Infinity;
        cards.forEach(function(card) {
          var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < nearest) { nearest = distance; current = card; }
        });
        cards.forEach(function(card) { card.classList.toggle('is-current', card === current); });
      }
      track.addEventListener('scroll', function() {
        if (!frame) frame = requestAnimationFrame(updateCurrent);
      }, { passive: true });
      track.addEventListener('click', function(event) {
        var card = event.target.closest('[data-cw-pair-card]');
        if (card && !card.classList.contains('is-current')) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
      updateCurrent();
      track.dataset.ready = 'true';
    }

    /* Swap the drawer's INNER regions (header/body/footer) instead of the whole
       <aside>. The drawer root is the element the open/close transform animates
       on, replacing the root mid-slide (the old behaviour) killed the animation
       dead: the freshly inserted node rendered instantly at fully-open, so on
       fast connections the slide visibly teleported. Keeping the root stable
       means the slide always completes smoothly, the list scroll position
       survives quantity changes, and state classes carry over naturally.
       Returns false when either tree is missing a region (caller falls back to
       a whole-node swap). */
    function swapDrawerRegions(oldDrawer, newDrawer) {
      var selectors = ['.cw-cart-drawer__header', '.cw-cart-drawer__body', '.cw-cart-drawer__footer'];
      for (var i = 0; i < selectors.length; i++) {
        if (!oldDrawer.querySelector(selectors[i]) || !newDrawer.querySelector(selectors[i])) return false;
      }

      var oldBody = oldDrawer.querySelector('.cw-cart-drawer__body');
      var prevScroll = oldBody ? oldBody.scrollTop : 0;
      var oldTotalEl = oldDrawer.querySelector('.cw-cart-drawer__total strong');
      var prevTotal = oldTotalEl ? oldTotalEl.textContent : null;
      var wasUpdating = oldDrawer.classList.contains('is-updating');

      selectors.forEach(function(sel) {
        oldDrawer.querySelector(sel).replaceWith(newDrawer.querySelector(sel));
      });

      /* The root persists now, so the loading skeleton must be cleared here
         (the old whole-node swap discarded the is-updating class implicitly). */
      oldDrawer.classList.remove('is-updating');

      /* Keep the shopper's place in the list on quantity changes. After an
         optimistic open (skeleton) the list intentionally starts at the top. */
      var newBody = oldDrawer.querySelector('.cw-cart-drawer__body');
      if (newBody && prevScroll && !wasUpdating) newBody.scrollTop = prevScroll;

      /* Subtotal micro-animation when the amount actually changed. */
      var newTotalEl = oldDrawer.querySelector('.cw-cart-drawer__total strong');
      if (newTotalEl && prevTotal !== null && newTotalEl.textContent !== prevTotal) {
        newTotalEl.classList.add('cw-cart-total--pulse');
      }

      /* Real content just replaced the loading skeleton, cascade the items in.
         In-place updates (quantity change etc.) must NOT re-run the entrance
         animation, so any leftover is-entering is dropped instead. */
      if (wasUpdating && document.body.classList.contains('cw-cart-open')) {
        restartEnterCascade();
      } else {
        oldDrawer.classList.remove('is-entering');
      }
      return true;
    }

    /* Swap the drawer + cart count from a freshly rendered DOM tree (either a
       section fragment or a full document). Keeps the existing drawer node's
       open state by relying on the body.cw-cart-open selector, so no re-pop. */
    function applyDrawerFromRoot(root, keepOpen, giftToastType) {
      var oldDrawer = document.querySelector('[data-cw-cart-drawer]');
      var newDrawer = root.querySelector('[data-cw-cart-drawer]');
      /* Filter the express wallets while the new drawer is still a detached fragment: the
         accelerated-checkout component reads `wallet-configs` only when it hydrates (which
         happens synchronously on insertion once its script has loaded), so this is the last
         moment the wallet list can change cleanly. Policy + rationale live next to the
         express markup in cw-header.liquid. */
      if (newDrawer && window.CWWalletPolicy) {
        try { window.CWWalletPolicy.apply(newDrawer); } catch (e) { /* fail open */ }
      }
      /* Cart updates carry an empty holder instead of the payment icons; move the
         icons already on the page into it (see the drawer footer in cw-header.liquid). */
      if (oldDrawer && newDrawer) {
        var paymentsHolder = newDrawer.querySelector('[data-cw-keep-payments]');
        var paymentsNow = oldDrawer.querySelector('.cw-cart-payments:not([data-cw-keep-payments])');
        if (paymentsHolder && paymentsNow) paymentsHolder.replaceWith(paymentsNow);
      }
      if (oldDrawer && newDrawer) {
        if (!swapDrawerRegions(oldDrawer, newDrawer)) oldDrawer.replaceWith(newDrawer);
      }

      var oldCount = document.querySelector('.cw-cart-count');
      var newCount = root.querySelector('.cw-cart-count');
      var cartButton = document.querySelector('[data-cw-cart-open]');
      var prevCountText = oldCount ? oldCount.textContent.trim() : null;

      if (oldCount && newCount) oldCount.replaceWith(newCount);
      else if (!oldCount && newCount && cartButton) cartButton.appendChild(newCount);
      else if (oldCount && !newCount) oldCount.remove();

      /* Badge pop when the item count changes. The badge is a fresh node on
         every swap, so the animation replays naturally on insertion. */
      if (newCount && newCount.textContent.trim() !== prevCountText) {
        newCount.classList.add('cw-cart-count--pop');
      }

      initOfferCarousel();
      initPairCarousel();

      if (keepOpen) openCart();
      setCartBusy(cartMutating || syncing);
      return true;
    }

    /* Original behaviour, kept only as a safety fallback. */
    function refreshFromFullPage(keepOpen, giftToastType) {
      return fetch(window.location.pathname + window.location.search, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(response) {
          if (response.status === 429) { var rl = new Error(cwT('Cart is updating too quickly. Please wait a moment and try again.')); rl.code = 'RATE_LIMITED'; throw rl; }
          if (!response.ok) throw new Error('Full-page refresh failed');
          return response.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ok = applyDrawerFromRoot(doc, keepOpen, giftToastType);
          CWPerf.mark('refresh:dom-updated (fallback full-page)');
          return ok;
        });
    }

    function refreshCartDrawer(keepOpen, giftToastType) {
      if (refreshing) return Promise.resolve(false);
      refreshing = true;
      CWPerf.mark('refresh:fetch-start');

      /* Fast path: Shopify Section Rendering API returns ONLY this header
         section's HTML as JSON, instead of the entire product page. A
         <template> fragment parse is far cheaper than full-document DOMParser. */
      var url = sectionsUrl();
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(headerSectionId);

      return fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(response) {
          if (response.status === 429) { var rl = new Error(cwT('Cart is updating too quickly. Please wait a moment and try again.')); rl.code = 'RATE_LIMITED'; throw rl; }
          if (!response.ok) throw new Error('Section fetch failed');
          return response.json().catch(function() { throw new Error('Section payload not JSON'); });
        })
        .then(function(data) {
          CWPerf.mark('refresh:section-response');
          var html = data && data[headerSectionId];
          if (!html) throw new Error('Section payload empty');
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          if (!tpl.content.querySelector('[data-cw-cart-drawer]')) {
            throw new Error('Drawer not in section payload');
          }
          var ok = applyDrawerFromRoot(tpl.content, keepOpen, giftToastType);
          CWPerf.mark('refresh:dom-updated (section)');
          return ok;
        })
        .catch(function(error) {
          /* On a rate limit, do NOT hammer the server with a full-page refresh
             too, bail out quietly and let the loading states clear. */
          if (error && error.code === 'RATE_LIMITED') {
            CWPerf.flag('rateLimited', true);
            return false;
          }
          /* This warning is the signal that the optimized path is NOT working.
             During normal successful adds it should never appear. */
          console.warn('[CW Cart] Section Rendering API path failed, falling back to full-page refresh.', (error && error.message) || error);
          return refreshFromFullPage(keepOpen, giftToastType);
        })
        .finally(function() {
          refreshing = false;
          /* Guarantee the spinner clears even if every refresh attempt failed
             (e.g. offline), so the drawer is never left spinning. */
          stopCartLoading();
        });
    }

    /* =====================================================================
       OPTIMIZED CART FLOW
       Goal: collapse the old add → /cart.js → gift1 → gift2 → section-fetch
       chain (and the remove → /cart.js → gift cleanup → section-fetch chain)
       into a single bundled request whenever it is safe.
       Two ideas:
         1) Read current cart state from the rendered drawer DOM instead of
            calling /cart.js (each line exposes data-is-watch / data-is-free-gift
            / data-variant-id / data-item-key / [data-cw-cart-line-qty]).
         2) Use the Cart Ajax API "sections" parameter so /cart/add.js and
            /cart/update.js return the refreshed drawer HTML in the SAME
            response, no separate refreshCartDrawer fetch.
       ===================================================================== */
    function sectionsUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root + 'cart';
    }

    function readCartStateFromDOM() {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      var els = drawer ? drawer.querySelectorAll('[data-cw-cart-item]') : [];
      var state = { watchCount: 0, giftsByVariant: {}, lines: [], hasDrawer: !!drawer };
      Array.prototype.forEach.call(els, function(el) {
        var variantId = String(el.getAttribute('data-variant-id') || '');
        var qtyEl = el.querySelector('[data-cw-cart-line-qty]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (isNaN(qty) || qty < 1) qty = 1;
        var line = {
          variantId: variantId,
          key: el.getAttribute('data-item-key'),
          isWatch: el.getAttribute('data-is-watch') === 'true',
          isGift: el.getAttribute('data-is-free-gift') === 'true',
          isOrphanEngraving: el.getAttribute('data-is-engraving') === 'true',
          isAddonProduct: /add-on/i.test(el.getAttribute('data-product-type') || ''),
          hasEngraving: el.getAttribute('data-has-engraving') === 'true',
          qty: qty
        };
        state.lines.push(line);
        if (line.isGift) {
          (state.giftsByVariant[variantId] = state.giftsByVariant[variantId] || []).push(line);
        } else if (line.isWatch) {
          state.watchCount += qty;
        }
      });
      return state;
    }

    /* Each watch receives a case and sizing kit. Exactly two watches receive
       one rubber strap; three or more receive one mystery box instead. */
    function requiredGiftQuantities(watchCount) {
      var quantities = {};
      watchCount = Math.max(0, Number(watchCount) || 0);
      if (watchCount >= 1) {
        if (watchCaseVariantId) quantities[String(watchCaseVariantId)] = watchCount;
        if (adjustmentKitVariantId) quantities[String(adjustmentKitVariantId)] = watchCount;
      }
      if (watchCount === 2 && bonusGiftVariantId) quantities[String(bonusGiftVariantId)] = 1;
      if (watchCount >= 3 && mysteryGiftVariantId) quantities[String(mysteryGiftVariantId)] = 1;
      return quantities;
    }

    function giftToastTypeForVariants(variantIds) {
      return (variantIds && variantIds.length) ? 'standard' : null;
    }

    /* Render the drawer from sections returned in a cart mutation response. */
    function applyDrawerFromSections(sections, keepOpen, giftToastType) {
      var html = sections && sections[headerSectionId];
      if (!html) return false;
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      if (!tpl.content.querySelector('[data-cw-cart-drawer]')) return false;
      applyDrawerFromRoot(tpl.content, keepOpen, giftToastType);
      CWPerf.flag('bundledSection', true);
      return true;
    }

    function postCartJson(url, body, label) {
      var doneNet = CWPerf.net(label || url);
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(response) {
        doneNet();
        return parseCartResponse(response, { method: 'POST', label: label || url, sent: summarizePayload(body) });
      });
    }

    /* Add main item(s) + any MISSING required gifts in ONE /cart/add.js request,
       and refresh the drawer from sections in the same response.
       opts.watchesAdded = eligible paid watches contained in `items`. */
    function addToCartBundled(items, opts) {
      opts = opts || {};
      openCartLoading();

      var pre = readCartStateFromDOM();
      /* Adding to a cart that has no watches is a fresh start, clear any stale
         "removed gift" preference so the new watch gets its full gift set. */
      resetRemovedGiftsIfNoWatch(pre.watchCount);
      var newWatchCount = pre.watchCount + (Number(opts.watchesAdded) || 0);
      var requiredQuantities = requiredGiftQuantities(newWatchCount);
      var obsolete = {};
      pre.lines.forEach(function(line) {
        if (line.isGift && !requiredQuantities[line.variantId]) obsolete[line.key] = 0;
      });
      var required = Object.keys(requiredQuantities);
      var removed = getRemovedGifts();
      var giftVariantsAdded = [];
      var giftItems = [];

      required.forEach(function(variantId) {
        var presentLines = pre.giftsByVariant[variantId] || [];
        var presentQuantity = presentLines.reduce(function(total, line) { return total + Number(line.qty || 0); }, 0);
        var missingQuantity = requiredQuantities[variantId] - presentQuantity;
        if (missingQuantity > 0 && removed.indexOf(variantId) === -1) {
          giftItems.push({ id: Number(variantId), quantity: missingQuantity, properties: { _free_gift: 'true' } });
          giftVariantsAdded.push(variantId);
        }
      });

      /* Shipping protection rides along with the first watch (one per order). */
      /* Shipping protection rides along with the first watch (back on, merchant, Oct 6, 2026). */
      var protection = protectionState();
      if (protection && Number(opts.watchesAdded) > 0 && !protection.inCart && !protection.optout && protection.available && protection.variantId) {
        giftItems.push({ id: protection.variantId, quantity: 1 });
      }

      var body = {
        items: (items || []).concat(giftItems),
        sections: headerSectionId,
        sections_url: sectionsUrl()
      };

      CWPerf.mark('add:request-start (items=' + body.items.length + ', bundled-gifts=' + giftItems.length + ')');
      var cleanup = Object.keys(obsolete).length
        ? postCartJson(window.CWCartConfig.routes.cartUpdate, { updates: obsolete }, '/cart/update.js (old tier gift)')
        : Promise.resolve();
      return cleanup.then(function() {
          return postCartJson(window.CWCartConfig.routes.cartAdd, body, '/cart/add.js');
        })
        .then(function(data) {
          CWPerf.mark('add:response');
          var toastType = giftToastTypeForVariants(giftVariantsAdded);
          if (data && data.__unparsed) {
            /* Add returned 2xx but no usable body, the item IS in the cart.
               Refresh the drawer once via the safe section path; NOT a failure. */
            CWPerf.flag('bundledUnparseable', true);
            return refreshCartDrawer(true, toastType).then(function() { return data; });
          }
          var used = applyDrawerFromSections(data && data.sections, true, toastType);
          if (!used) {
            CWPerf.flag('bundledSection', false);
            return refreshCartDrawer(true, toastType);
          }
          CWPerf.mark('drawer-updated (bundled section)');
          return data;
        })
        .then(function(data) {
          return reconcileGiftsFromDOM(true).then(function() { return data; });
        });
    }

    function setCartBusy(busy) {
      if (!busy) scheduleProtectionCheck();
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
      var checkout = document.querySelector('.cw-cart-drawer__claim');
      if (checkout) checkout.disabled = busy || !readCartStateFromDOM().lines.length;
    }
    var pendingAdd = null;
    function guardedAddToCart(items, opts) {
      if (pendingAdd) return pendingAdd;
      if (cartMutating) return Promise.reject(new Error(cwT('Please wait for your cart to finish updating.')));
      cartMutating = true;
      setCartBusy(true);
      pendingAdd = addToCartBundled(items, opts).finally(function() {
        pendingAdd = null;
        cartMutating = false;
        setCartBusy(false);
      });
      return pendingAdd;
    }
    window.CWAddToCartBundled = guardedAddToCart;

    /* Update multiple line items (keyed by line item key) in ONE /cart/update.js
       request and refresh the drawer from sections in the same response.
       Returns the updated cart JSON (so callers can inspect it with no /cart.js). */
    function updateCartBundled(updates, opts) {
      opts = opts || {};
      var keepOpen = opts.keepOpen !== false;
      var body = { updates: updates, sections: headerSectionId, sections_url: sectionsUrl() };
      CWPerf.mark('update:request-start (lines=' + Object.keys(updates).length + ')');
      return postCartJson(window.CWCartConfig.routes.cartUpdate, body, '/cart/update.js')
        .then(function(cart) {
          CWPerf.mark('update:response');
          if (cart && cart.__unparsed) {
            /* Update returned 2xx but no usable body, the change DID apply.
               Refresh the drawer once via the safe section path; NOT a failure. */
            CWPerf.flag('bundledUnparseable', true);
            return refreshCartDrawer(keepOpen, opts.giftToastType || null).then(function() { return cart; });
          }
          var used = applyDrawerFromSections(cart && cart.sections, keepOpen, opts.giftToastType || null);
          if (!used) {
            CWPerf.flag('bundledSection', false);
            return refreshCartDrawer(keepOpen, opts.giftToastType || null).then(function() { return cart; });
          }
          CWPerf.mark('drawer-updated (bundled section)');
          return cart;
        });
    }

    /* Remove engraving add-ons orphaned by a removal, using the cart JSON we
       already have from the update response (no extra /cart.js). Issues a
       follow-up request ONLY when orphans actually exist. */
    function cleanupOrphanEngravingsFromCart(cart) {
      if (!cart || !cart.items) return Promise.resolve(cart);
      var presentGroupIds = {}, presentTitles = {};
      cart.items.forEach(function(item) {
        if (isEngravingAddonItem(item)) return;
        var props = item.properties || {};
        if (props['_Engraving Group ID']) presentGroupIds[String(props['_Engraving Group ID'])] = true;
        if (props['_Addon Group ID']) presentGroupIds[String(props['_Addon Group ID'])] = true;
        var title = String(item.product_title || item.title || '');
        if (title) presentTitles[title] = true;
      });
      var updates = {};
      var any = false;
      var hasWatch = cartHasWatch(cart.items);
      cart.items.forEach(function(item) {
        var addonProduct = isAddonProductItem(item);
        if (!isEngravingAddonItem(item) && !addonProduct) return;
        var gid = linkGroupId(item.properties);
        var orphan;
        if (addonProduct && !hasWatch) {
          orphan = true;
        } else if (gid) {
          orphan = !presentGroupIds[String(gid)];
        } else {
          var linked = String((item.properties && item.properties['_Linked Watch']) || '');
          orphan = linked !== '' && !presentTitles[linked];
        }
        if (orphan) { updates[item.key] = 0; any = true; }
      });
      if (!any) return Promise.resolve(cart);
      CWPerf.flag('orphanEngravingCleanup', true);
      return updateCartBundled(updates, { keepOpen: true });
    }

    /* The drawer can contain split lines after Shopify recalculates discounts.
       Repair from a fresh cart snapshot whenever the rendered gifts disagree
       with the tier; do not mutate keys copied from the old drawer. */
    function reconcileGiftsFromDOM(keepOpen) {
      var state = readCartStateFromDOM();
      if (!state.hasDrawer) return Promise.resolve(false);
      resetRemovedGiftsIfNoWatch(state.watchCount);
      var requiredQuantities = requiredGiftQuantities(state.watchCount);
      var removed = getRemovedGifts();
      /* An add-on product line with no watch in the cart (Oct 15, 2026) is cleaned
         up on drawer open as well, not only after a change. */
      var strayAddon = state.watchCount === 0 && state.lines.some(function(line) { return line.isAddonProduct; });
      var mismatch = strayAddon || state.lines.some(function(line) { return line.isOrphanEngraving; });
      Object.keys(state.giftsByVariant).forEach(function(id) {
        var lines = state.giftsByVariant[id];
        if (!requiredQuantities[id]) mismatch = true;
        else if (removed.indexOf(id) === -1 &&
          (lines.length !== 1 || lines[0].qty !== requiredQuantities[id])) mismatch = true;
      });
      Object.keys(requiredQuantities).forEach(function(id) {
        if (!state.giftsByVariant[id] && removed.indexOf(id) === -1) mismatch = true;
      });
      if (!mismatch) {
        CWPerf.mark('reconcile: gifts already correct (0 requests)');
        return Promise.resolve(false);
      }
      var orphaned = strayAddon || state.lines.some(function(line) { return line.isOrphanEngraving; });
      var cleanup = orphaned ? removeOrphanedEngravings() : Promise.resolve();
      return cleanup.then(function() { return syncGifts(null, keepOpen); }).then(function(result) {
        return result && result.rendered ? true : refreshCartDrawer(keepOpen !== false, result && result.giftToastType);
      });
    }

    /* One delegated close/open handler that still works after drawer HTML is replaced. */
    document.addEventListener('click', function(event) {
      /* Reward info popups in the free gifts tracker. */
      var rewardInfo = event.target.closest('[data-cw-reward-info]');
      if (rewardInfo) {
        var rewardDialog = rewardInfo.parentNode.querySelector('.cw-reward-dialog');
        if (rewardDialog && rewardDialog.showModal) rewardDialog.showModal();
        return;
      }
      /* Close on the X or on a tap outside the card (the backdrop is the dialog itself). */
      if (event.target.closest('[data-cw-reward-close]') || event.target.matches('.cw-reward-dialog')) {
        event.target.closest('.cw-reward-dialog').close();
        return;
      }

      var closeBtn = event.target.closest('[data-cw-cart-close]');
      if (closeBtn) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeCart();
        return;
      }

      var openBtn = event.target.closest('[data-cw-cart-open]');
      if (openBtn) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openCart();
        return;
      }

      var toastClose = event.target.closest('[data-cw-free-gift-toast-close], [data-cw-bonus-gift-toast-close]');
      if (toastClose) {
        event.preventDefault();
        var toast = toastClose.closest('.cw-free-gift-toast');
        if (toast) {
          window.clearTimeout(window.CWGiftToastTimer);
          window.clearTimeout(window.CWBonusGiftToastTimer);
          hideGiftToastEl(toast);
        }
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && document.querySelector('[data-cw-cart-sheet]')) {
        closeSheet();
        return;
      }
      if (event.key === 'Escape' && document.body.classList.contains('cw-cart-open') && !document.querySelector('.cw-reward-dialog[open]')) {
        closeCart();
      }
    });

    /* Add-to-cart without reload; then add gifts once, refresh drawer, and show toast. */
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;
      if (form.querySelector('[data-cw-engraving-form-flag]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      /* Block duplicate submits while this form's add is already in flight
         (rapid double-taps would otherwise fire multiple /cart/add requests). */
      if (form.getAttribute('data-cw-adding') === '1' || cartMutating) return;
      form.setAttribute('data-cw-adding', '1');
      var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (submitBtn) submitBtn.disabled = true;
      function clearAddingState() {
        form.removeAttribute('data-cw-adding');
        if (submitBtn) submitBtn.disabled = false;
      }

      CWPerf.start('click→submit (header path)');
      /* Instant feedback: slide the drawer in now, in its loading state. */
      openCartLoading();
      CWPerf.mark('drawer-open (optimistic)');

      var addOk = false;
      /* Build the add item from the form so we can bundle gifts + sections in
         one request. Quick-add forms carry id (+ optional quantity). */
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var addPromise;

      if (idField && idField.value) {
        var item = { id: Number(idField.value), quantity: Number((qtyField && qtyField.value) || 1) || 1 };
        /* Preserve configurator and other line-item properties when using the
           optimized JSON add path. The previous shortcut sent only id/quantity,
           which discarded a custom watch's selected build details. */
        var formData = new FormData(form);
        var properties = {};
        formData.forEach(function(value, key) {
          var match = String(key).match(/^properties\[(.+)\]$/);
          if (match && String(value) !== '') properties[match[1]] = String(value);
        });
        if (Object.keys(properties).length) item.properties = properties;
        var sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;
        var items = [item];
        /* Explicit watch forms (including the configurator) can bundle gifts in
           this request. Unknown quick-add forms reconcile from the drawer. */
        var watchesAdded = form.hasAttribute('data-cw-watch-form') ? item.quantity : 0;
        addPromise = guardedAddToCart(items, { watchesAdded: watchesAdded })
          .then(function() { addOk = true; return reconcileGiftsFromDOM(true); });
      } else {
        /* Unknown form shape, safe fallback to the original FormData flow. */
        var doneNet = CWPerf.net('/cart/add.js (formdata fallback)');
        addPromise = fetch(window.CWCartConfig.routes.cartAdd, {
          method: 'POST', credentials: 'same-origin', body: new FormData(form), headers: { 'Accept': 'application/json' }
        }).then(function(response) {
          doneNet();
          return parseCartResponse(response);
        }).then(function() { addOk = true; return syncGifts(); })
          .then(function(result) { return result && result.rendered ? true : refreshCartDrawer(true, result && result.giftToastType); });
      }

      addPromise
        .then(function() { CWPerf.end('add complete'); })
        .catch(function(error) {
          console.error(error);
          if (error && error.code === 'RATE_LIMITED') {
            /* Don't resync on a 429, that just adds another request. */
            failCartLoading();
            notifyCartError(error);
          } else if (addOk) {
            /* Item is in the cart; only gift-sync/refresh failed, resync. */
            refreshCartDrawer(true, false);
          } else {
            /* Nothing was added, clear the spinner and undo the optimistic open. */
            failCartLoading();
          }
        })
        .finally(clearAddingState);
    }, true);

    window.CWSyncGiftsAndRefreshCart = function(keepOpen) {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (drawer) drawer.classList.add('is-updating');

      return syncGifts(null, keepOpen)
        .then(function(result) {
          return result && result.rendered ? true : refreshCartDrawer(keepOpen !== false, result && result.giftToastType);
        })
        .catch(function(error) {
          console.error(error);
          /* Don't issue another request on a rate limit; surface it to the caller. */
          if (error && error.code === 'RATE_LIMITED') { stopCartLoading(); throw error; }
          return refreshCartDrawer(keepOpen !== false, false);
        });
    };

    /* Quantity/remove without reload; keep cart open.
       Fast path: ONE /cart/update.js that changes the line AND fixes gift
       quantities, refreshing the drawer from sections in the same response.
       Cart state is read from the drawer DOM, so there is no /cart.js call. */
    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-cw-cart-change]');
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var line = Number(button.getAttribute('data-line'));
      var itemEl = button.closest('[data-cw-cart-item]');
      var itemKey = button.getAttribute('data-key') || (itemEl && itemEl.getAttribute('data-item-key'));
      var newQty = Number(button.getAttribute('data-quantity'));
      if ((!itemKey && !line) || isNaN(newQty)) return;
      /* Gift lines are locked: quantity follows the watch count and a gift
         cannot be removed on its own. */
      if (itemEl && itemEl.getAttribute('data-is-free-gift') === 'true') return;
      if (cartMutating) return;                 // in-flight guard: ignore rapid repeat taps
      cartMutating = true;
      setCartBusy(true);

      CWPerf.start('click→cart-change');

      /* Line-level feedback on the affected item (no big drawer-wide spinner),
         so the rest of the drawer stays responsive while one line changes.
         Removals collapse the row immediately (premium feel + perceived speed);
         quantity changes show the small line spinner. */
      if (itemEl) {
        if (newQty === 0) startRemoveCollapse(itemEl);
        else itemEl.classList.add('cw-cart-item--loading');
      }

      var state = readCartStateFromDOM();
      var thisLine = null;
      for (var i = 0; i < state.lines.length; i++) {
        if (state.lines[i].key === itemKey) { thisLine = state.lines[i]; break; }
      }
      var curQty = thisLine ? thisLine.qty : 1;
      var isWatch = thisLine ? thisLine.isWatch : false;

      /* A personalized watch and its paid engraving add-ons are a one-to-one
         bundle. Increasing the parent line alone would duplicate the watch but
         not the engraving charge, so each personalized watch must be added as
         its own cart line. Removal is still allowed and removes the exact linked
         add-on keys in the same request below. */
      if (isWatch && thisLine && thisLine.hasEngraving && newQty > 1) {
        if (itemEl) itemEl.classList.remove('cw-cart-item--loading');
        cartMutating = false;
        setCartBusy(false);
        window.alert(cwT('A watch with engraving or add-ons is added one at a time, so each one is charged correctly. Add another from the watch page.'));
        return;
      }

      var newWatchCount = state.watchCount;
      if (isWatch) newWatchCount = state.watchCount - curQty + newQty;
      /* If this change leaves no watches, forget removed-gift preferences so a
         future watch add restores the full gift set. */
      resetRemovedGiftsIfNoWatch(newWatchCount);
      var removed = getRemovedGifts();
      var desiredQuantities = requiredGiftQuantities(newWatchCount);
      var desired = Object.keys(desiredQuantities);

      /* Crossing a tier in either direction can require a different gift.
         /cart/update.js cannot add a line with the _free_gift property. */
      var needsGiftAdd = false;
      if (isWatch) {
        desired.forEach(function(v) {
          var present = state.giftsByVariant[v] && state.giftsByVariant[v].length;
          if (!present && removed.indexOf(v) === -1) needsGiftAdd = true;
        });
      }

      if (!itemKey) {
        CWPerf.flag('fallbackReconcile', true);
        var drawer = document.querySelector('[data-cw-cart-drawer]');
        if (drawer) drawer.classList.add('is-updating');
        var doneChange = CWPerf.net(line ? '/cart/change.js' : '/cart/change.js');
        (line ? changeLine(line, newQty) : changeByKey(itemKey, newQty))
          .then(function(cart) { doneChange(); return cleanupOrphanEngravingsFromCart(cart); })
          .then(function(cart) { return syncGifts(cart, true); })
          .then(function(result) { return result && result.rendered ? true : refreshCartDrawer(true, result && result.giftToastType); })
          .then(function() { CWPerf.end('cart-change complete (reconcile path)'); })
          .catch(function(error) {
            console.error(error);
            stopCartLoading();
            if (error && error.code === 'RATE_LIMITED') { notifyCartError(error); }
            else { refreshCartDrawer(true, false); }
          })
          .finally(function() { cartMutating = false; setCartBusy(false); });
        return;
      }

      /* Bundled single-request path: set this line + correct gift quantities. */
      var updates = {};
      updates[itemKey] = newQty;
      Object.keys(state.giftsByVariant).forEach(function(variantId) {
        var arr = state.giftsByVariant[variantId];
        if (desired.indexOf(variantId) === -1) {
          arr.forEach(function(g) { updates[g.key] = 0; });            // no longer required → remove
        } else if (removed.indexOf(variantId) === -1) {
          arr.forEach(function(g, idx) {
            if (idx === 0) { if (g.qty !== desiredQuantities[variantId]) updates[g.key] = desiredQuantities[variantId]; }
            else updates[g.key] = 0;                                    // drop duplicates
          });
        }
      });

      /* Removing a watch line: remove its linked engraving add-ons in the SAME
         request (keys emitted on the watch row as data-cw-engraving-keys), so an
         engraving never lingers as its own orphan line. */
      if (newQty === 0 && itemEl) {
        var engKeys = itemEl.getAttribute('data-cw-engraving-keys');
        if (engKeys) {
          engKeys.split(',').forEach(function(k) { k = k.trim(); if (k) updates[k] = 0; });
        }
      }

      updateCartBundled(updates, { keepOpen: true })
        .then(function(cart) { return cleanupOrphanEngravingsFromCart(cart); })
        .then(function(cart) {
          if (!needsGiftAdd) return reconcileGiftsFromDOM(true);
          return syncGifts(cart, true).then(function(result) {
            return result && result.rendered ? true : refreshCartDrawer(true, result && result.giftToastType);
          });
        })
        .then(function() { CWPerf.end('cart-change complete (bundled)'); })
        .catch(function(error) {
          console.error(error);
          stopCartLoading();
          if (error && error.code === 'RATE_LIMITED') { notifyCartError(error); }
          else { refreshCartDrawer(true, false); }
        })
        .finally(function() { cartMutating = false; setCartBusy(false); });
    }, true);

    /* =====================================================================
       DRAWER SHEETS (website makeover, October 6, 2026)
       A sheet slides up inside the drawer root, which a drawer refresh never
       replaces, so the editor stays open while the cart updates behind it.
       Used by the engraving editor (plan 5.1) and the shipping protection
       warning.
       ===================================================================== */
    function closeSheet() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cw-cart-sheet]'), function(sheet) { sheet.remove(); });
    }

    function openSheet(name, label, fill) {
      var drawer = document.querySelector('[data-cw-cart-drawer]');
      if (!drawer) return null;
      closeSheet();
      var sheet = document.createElement('div');
      sheet.className = 'cw-cart-sheet cw-cart-sheet--' + name;
      sheet.setAttribute('data-cw-cart-sheet', name);
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.setAttribute('aria-label', label);
      fill(sheet);
      drawer.appendChild(sheet);
      window.requestAnimationFrame(function() { sheet.classList.add('is-open'); });
      return sheet;
    }

    /* ---------- Engraving inside the drawer ---------- */
    var engravingScript = null;
    function loadEngravingScript() {
      if (window.CWEngraving) return Promise.resolve();
      if (engravingScript) return engravingScript;
      engravingScript = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = window.CWCartConfig.engravingJs;
        script.onload = resolve;
        script.onerror = function() { engravingScript = null; reject(new Error(cwT('The engraving editor did not load. Please try again.'))); };
        document.head.appendChild(script);
      });
      return engravingScript;
    }

    function engravingCards(sheet) {
      return Array.prototype.slice.call(sheet.querySelectorAll('[data-cw-engraving-card]')).filter(function(card) { return !card.hidden; });
    }

    function checkedEngravingCards(sheet) {
      return engravingCards(sheet).filter(function(card) {
        var toggle = card.querySelector('[data-cw-engraving-toggle]');
        return toggle && toggle.checked;
      });
    }

    function formatCents(cents) {
      var config = window.CWCartConfig.moneyFormat || '${{amount}}';
      var amount = (Number(cents || 0) / 100).toFixed(2);
      return config.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    function updateEngravingSave(sheet) {
      var save = sheet.querySelector('[data-cw-cart-eng-save]');
      if (!save) return;
      var total = checkedEngravingCards(sheet).reduce(function(sum, card) {
        return sum + Number(sheet.getAttribute('data-' + card.getAttribute('data-engraving-type') + '-price') || 0);
      }, 0);
      save.disabled = total <= 0;
      save.textContent = total > 0 ? cwT('Add engraving, +{price}', {price: formatCents(total)}) : cwT('Pick a spot to engrave');
    }

    function openEngravingSheet(button) {
      var template = document.querySelector('[data-cw-cart-eng-template]');
      if (!template) return;
      var types = String(button.getAttribute('data-types') || 'crown').split(',');
      var sheet = openSheet('engrave', cwT('Add engraving'), function(node) {
        node.appendChild(template.content.cloneNode(true));
        Array.prototype.forEach.call(template.attributes, function(attr) {
          if (/^data-(crown|rotor|caseback|clasp)-/.test(attr.name)) node.setAttribute(attr.name, attr.value);
        });
      });
      if (!sheet) return;
      sheet.setAttribute('data-key', button.getAttribute('data-key') || '');
      var watch = sheet.querySelector('[data-cw-cart-eng-watch]');
      if (watch) watch.textContent = cwT('For your {title}', {title: button.getAttribute('data-title') || cwT('watch')});
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-cw-engraving-card]'), function(card) {
        var on = types.indexOf(card.getAttribute('data-engraving-type')) !== -1;
        card.hidden = !on;
        var toggle = card.querySelector('[data-cw-engraving-toggle]');
        if (toggle) toggle.disabled = !on;
      });
      updateEngravingSave(sheet);
      /* Start loading the editor while the shopper reads the options. */
      loadEngravingScript().catch(function() {});
    }

    function setSheetError(sheet, message) {
      var error = sheet.querySelector('[data-cw-cart-eng-error]');
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }

    function saveEngraving(sheet) {
      var cards = checkedEngravingCards(sheet);
      if (!cards.length || cartMutating) return;
      if (!window.CWEngraving) { setSheetError(sheet, cwT('One moment, the editor is still loading.')); return; }
      var firstBad = null;
      var picks = cards.map(function(card) {
        var message = window.CWEngraving.validate(card);
        var error = card.querySelector('[data-cw-engraving-error]');
        if (error) { error.textContent = message; error.hidden = !message; }
        if (message && !firstBad) firstBad = card;
        var type = card.getAttribute('data-engraving-type');
        var toggle = card.querySelector('[data-cw-engraving-toggle]');
        var input = card.querySelector('[data-cw-engraving-input]');
        return {
          type: type,
          label: toggle.getAttribute('data-engraving-label'),
          propertyName: toggle.getAttribute('data-property-name'),
          text: String(input ? input.value : '').replace(/\s+/g, ' ').trim(),
          meta: window.CWEngraving.meta(card),
          variantId: Number(sheet.getAttribute('data-' + type + '-variant-id') || 0)
        };
      });
      if (firstBad) { firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (picks.some(function(pick) { return !pick.variantId; })) { setSheetError(sheet, cwT('This engraving is not available right now.')); return; }

      var save = sheet.querySelector('[data-cw-cart-eng-save]');
      var key = sheet.getAttribute('data-key');
      setSheetError(sheet, '');
      cartMutating = true;
      setCartBusy(true);
      if (save) { save.disabled = true; save.textContent = cwT('Adding...'); }

      fetchCart().then(function(cart) {
        var line = (cart.items || []).filter(function(item) { return item.key === key; })[0];
        if (!line) throw new Error(cwT('This watch is no longer in your cart.'));
        var props = {};
        Object.keys(line.properties || {}).forEach(function(name) {
          if (line.properties[name] !== null && line.properties[name] !== '') props[name] = line.properties[name];
        });
        var gid = linkGroupId(props) || (String(line.handle || 'watch') + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));
        props['_Engraving Group ID'] = gid;
        if (props['_Addon Group ID']) props['_Addon Group ID'] = gid;
        picks.forEach(function(pick) {
          props[pick.propertyName] = pick.meta && pick.meta.summary ? pick.text + ' (' + pick.meta.summary + ')' : pick.text;
        });
        var engravingItems = picks.map(function(pick) {
          return {
            id: pick.variantId,
            quantity: 1,
            properties: {
              '_Linked Watch': line.product_title,
              '_Engraving Group ID': gid,
              '_Engraving Type': pick.label.replace(' Engraving', ''),
              '_Engraving Text': pick.text,
              '_Engraving Font': pick.meta ? pick.meta.fontName : '',
              '_Engraving Size': pick.meta ? pick.meta.sizeName : '',
              '_Engraving Lines': pick.meta ? String(pick.meta.lines) : ''
            }
          };
        });
        var sections = { sections: headerSectionId, sections_url: sectionsUrl() };
        /* Several of the same watch on one line: engrave one of them as its own line. */
        if (Number(line.quantity) > 1) {
          return postCartJson(window.CWCartConfig.routes.cartAdd, {
            items: [{ id: line.variant_id, quantity: 1, properties: props }].concat(engravingItems)
          }, '/cart/add.js (engraved watch)').then(function() {
            return postCartJson(window.CWCartConfig.routes.cartChange, Object.assign({ id: line.key, quantity: Number(line.quantity) - 1 }, sections), '/cart/change.js (engraved watch)');
          });
        }
        return postCartJson(window.CWCartConfig.routes.cartChange, { id: line.key, quantity: 1, properties: props }, '/cart/change.js (engraving)')
          .then(function() {
            return postCartJson(window.CWCartConfig.routes.cartAdd, Object.assign({ items: engravingItems }, sections), '/cart/add.js (engraving)');
          });
      }).then(function(data) {
        closeSheet();
        if (!applyDrawerFromSections(data && data.sections, true, null)) return refreshCartDrawer(true, null);
      }).catch(function(error) {
        console.error(error);
        if (document.body.contains(sheet)) {
          setSheetError(sheet, (error && error.message) || cwT('Could not add the engraving. Please try again.'));
          updateEngravingSave(sheet);
        }
        refreshCartDrawer(true, null);
      }).finally(function() {
        cartMutating = false;
        setCartBusy(false);
      });
    }

    document.addEventListener('click', function(event) {
      var open = event.target.closest('[data-cw-cart-eng-open]');
      if (open) { event.preventDefault(); openEngravingSheet(open); return; }
      if (event.target.closest('[data-cw-cart-sheet-close]')) { event.preventDefault(); closeSheet(); return; }
      var save = event.target.closest('[data-cw-cart-eng-save]');
      if (save) { event.preventDefault(); saveEngraving(save.closest('[data-cw-cart-sheet]')); }
    });

    document.addEventListener('change', function(event) {
      var toggle = event.target;
      if (!toggle.matches || !toggle.matches('[data-cw-cart-sheet] [data-cw-engraving-toggle]')) return;
      var sheet = toggle.closest('[data-cw-cart-sheet]');
      var card = toggle.closest('[data-cw-engraving-card]');
      var editor = card.querySelector('[data-cw-engrave-editor]');
      if (editor) editor.hidden = !toggle.checked;
      card.classList.toggle('is-selected', toggle.checked);
      if (!toggle.checked) {
        var error = card.querySelector('[data-cw-engraving-error]');
        if (error) error.hidden = true;
      }
      setSheetError(sheet, '');
      updateEngravingSave(sheet);
      /* The editor script may still be on its way: when it lands, replay the tick so it draws the preview. */
      if (toggle.checked && !window.CWEngraving) {
        loadEngravingScript().then(function() {
          toggle.dispatchEvent(new Event('change', { bubbles: true }));
        }).catch(function(error) { setSheetError(sheet, error.message); });
      }
    });

    /* ---------- Shipping protection (October 6, 2026) ----------
       State comes from snippet cw-cart-protection. Added when a watch is in the cart,
       removed when none is left, one per order, never re-added after the shopper
       removes it (cart attribute _protection_removed). */
    function protectionState() {
      var el = document.querySelector('[data-cw-cart-drawer] [data-cw-protection-state]');
      if (!el) return null;
      return {
        variantId: Number(el.getAttribute('data-variant-id') || 0),
        available: el.getAttribute('data-available') === 'true',
        inCart: el.getAttribute('data-in-cart') === 'true',
        key: el.getAttribute('data-key') || '',
        qty: Number(el.getAttribute('data-qty') || 0),
        optout: el.getAttribute('data-optout') === 'true',
        watches: Number(el.getAttribute('data-watches') || 0)
      };
    }

    var protectionTimer = null;
    var protectionBusy = false;
    var protectionTries = 0;
    function scheduleProtectionCheck() {
      if (protectionTimer) window.clearTimeout(protectionTimer);
      protectionTimer = window.setTimeout(ensureProtection, 60);
    }

    function ensureProtection() {
      protectionTimer = null;
      if (protectionBusy || cartMutating || syncing || refreshing) return;
      /* No watch left: forget the removed choice so the next watch gets protection again. */
      if (document.querySelector('[data-cw-cart-drawer] [data-cw-protection-reset]') && protectionTries < 3) {
        protectionTries += 1;
        protectionBusy = true;
        postCartJson(window.CWCartConfig.routes.cartUpdate, { attributes: { _protection_removed: '' }, sections: headerSectionId, sections_url: sectionsUrl() }, '/cart/update.js (protection reset)')
          .then(function(data) { protectionTries = 0; applyDrawerFromSections(data && data.sections, document.body.classList.contains('cw-cart-open'), null); })
          .catch(function() {})
          .finally(function() { protectionBusy = false; });
        return;
      }
      var state = protectionState();
      if (!state) return;
      var body = null;
      var label = '';
      var url = window.CWCartConfig.routes.cartUpdate;
      /* Back on (merchant, Oct 6, 2026): pre-add with a watch, remove with no watch, one per order. */
      if (state.watches > 0 && !state.inCart && !state.optout && state.available && state.variantId) {
        url = window.CWCartConfig.routes.cartAdd;
        body = { items: [{ id: state.variantId, quantity: 1 }] };
        label = '/cart/add.js (shipping protection)';
      } else if (state.inCart && state.key && state.watches === 0) {
        body = { updates: {} };
        body.updates[state.key] = 0;
        label = '/cart/update.js (protection, no watch)';
      } else if (state.inCart && state.key && state.qty > 1) {
        body = { updates: {} };
        body.updates[state.key] = 1;
        label = '/cart/update.js (protection, one per order)';
      }
      if (!body || protectionTries >= 3) return;
      protectionTries += 1;
      protectionBusy = true;
      body.sections = headerSectionId;
      body.sections_url = sectionsUrl();
      postCartJson(url, body, label)
        .then(function(data) {
          protectionTries = 0;
          if (!applyDrawerFromSections(data && data.sections, document.body.classList.contains('cw-cart-open'), null)) {
            return refreshCartDrawer(document.body.classList.contains('cw-cart-open'), null);
          }
        })
        .catch(function(error) { console.warn('[CW Cart] shipping protection', error && error.message); })
        .finally(function() { protectionBusy = false; });
    }

    function openProtectionSheet(button) {
      var sheet = openSheet('protect', cwT('Remove shipping protection?'), function(node) {
        node.setAttribute('data-key', button.getAttribute('data-key') || '');
        var tick = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="#1a7f37" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        /* "Your watch: $X. Protection: $Y." from the drawer (snippet cw-cart-protection data attributes). */
        var stateEl = document.querySelector('[data-cw-cart-drawer] [data-cw-protection-state]');
        var esc = function(v) { return String(v || '').replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
        var watchTotal = stateEl ? stateEl.getAttribute('data-watch-total') : '';
        var protectionPrice = stateEl ? stateEl.getAttribute('data-protection-price') : '';
        var watchCount = stateEl ? Number(stateEl.getAttribute('data-watches') || 0) : 0;
        var prices = watchTotal && protectionPrice ? cwT(watchCount > 1 ? 'Your watches: <b>{watch}</b>. Protection: <b>{protection}</b>.' : 'Your watch: <b>{watch}</b>. Protection: <b>{protection}</b>.', {watch: esc(watchTotal), protection: esc(protectionPrice)}) : '';
        node.innerHTML =
          '<div class="cw-cart-sheet__panel">' +
          '<div class="cw-cart-sheet__head"><div><h3 class="cw-cart-sheet__title">' + cwT('Remove shipping protection?') + '</h3></div>' +
          '<button type="button" class="cw-cart-sheet__close" data-cw-protection-keep aria-label="' + cwT('Keep protection') + '"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button></div>' +
          '<div class="cw-cart-sheet__body cw-cart-protect-sheet">' +
          (prices ? '<p class="cw-cart-protect-sheet__prices">' + prices + '</p>' : '') +
          '<div class="cw-cart-protect-sheet__block"><span class="cw-cart-protect-sheet__label">' + cwT('Without protection') + '</span>' +
          '<p>' + cwT('If your parcel is lost, we help you look for it with the delivery company. We do not send a new watch. If it is stolen after delivery, it is not covered.') + '</p></div>' +
          '<div class="cw-cart-protect-sheet__block"><span class="cw-cart-protect-sheet__label cw-cart-protect-sheet__label--with">' + cwT('With protection') + '</span>' +
          '<p>' + cwT('We check with the delivery company. If your parcel is lost, stolen or damaged, we build and send you a new watch, <strong class="cw-cart-free">FREE</strong>.') + '</p></div>' +
          '<ul class="cw-cart-protect-sheet__ticks"><li>' + tick + cwT('Lost: we send a new watch') + '</li><li>' + tick + cwT('Stolen after delivery: we send a new watch') + '</li><li>' + tick + cwT('Damaged: we send a new watch') + '</li></ul>' +
          '<p class="cw-cart-eng__error" data-cw-cart-eng-error hidden></p></div>' +
          '<div class="cw-cart-sheet__foot">' +
          '<button type="button" class="cw-cart-sheet__primary" data-cw-protection-keep>' + cwT('Keep protection') + '</button>' +
          '<button type="button" class="cw-cart-sheet__link" data-cw-protection-confirm>' + cwT('Remove protection') + '</button></div>' +
          '</div>';
      });
      /* Tapping outside the panel keeps protection. */
      if (sheet) sheet.addEventListener('click', function(event) { if (event.target === sheet) closeSheet(); });
    }

    function addProtection(button) {
      if (cartMutating) return;
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
      cartMutating = true;
      setCartBusy(true);
      button.disabled = true;
      button.textContent = cwT('Adding...');
      var updates = {};
      updates[variantId] = 1;
      postCartJson(window.CWCartConfig.routes.cartUpdate, {
        updates: updates,
        attributes: { _protection_removed: '' },
        sections: headerSectionId,
        sections_url: sectionsUrl()
      }, '/cart/update.js (add protection)')
        .then(function(data) {
          if (!applyDrawerFromSections(data && data.sections, true, null)) return refreshCartDrawer(true, null);
        })
        .catch(function(error) {
          console.error(error);
          button.disabled = false;
          button.textContent = cwT('Add');
        })
        .finally(function() { cartMutating = false; setCartBusy(false); });
    }

    function removeProtection(sheet) {
      if (cartMutating) return;
      var key = sheet.getAttribute('data-key');
      var state = protectionState();
      if (!key && state) key = state.key;
      cartMutating = true;
      setCartBusy(true);
      var confirm = sheet.querySelector('[data-cw-protection-confirm]');
      if (confirm) { confirm.disabled = true; confirm.textContent = cwT('Removing...'); }
      var updates = {};
      if (key) updates[key] = 0;
      postCartJson(window.CWCartConfig.routes.cartUpdate, {
        updates: updates,
        attributes: { _protection_removed: 'yes' },
        sections: headerSectionId,
        sections_url: sectionsUrl()
      }, '/cart/update.js (remove protection)')
        .then(function(data) {
          closeSheet();
          if (!applyDrawerFromSections(data && data.sections, true, null)) return refreshCartDrawer(true, null);
        })
        .catch(function(error) {
          console.error(error);
          setSheetError(sheet, cwT('Could not remove it. Please try again.'));
          if (confirm) { confirm.disabled = false; confirm.textContent = cwT('Remove'); }
        })
        .finally(function() { cartMutating = false; setCartBusy(false); });
    }

    document.addEventListener('click', function(event) {
      var add = event.target.closest('[data-cw-protection-add]');
      if (add) { event.preventDefault(); addProtection(add); return; }
      var remove = event.target.closest('[data-cw-protection-remove]');
      if (remove) { event.preventDefault(); openProtectionSheet(remove); return; }
      if (event.target.closest('[data-cw-protection-keep]')) { event.preventDefault(); closeSheet(); return; }
      var confirm = event.target.closest('[data-cw-protection-confirm]');
      if (confirm) { event.preventDefault(); removeProtection(confirm.closest('[data-cw-cart-sheet]')); }
    });

    /* Last check before checkout (October 2, 2026): a watch never leaves the
       drawer for checkout without its gifts. If the drawer shows a watch with a
       gift missing, the gifts are added first and checkout continues by itself.
       An error or a slow network lets the shopper through instead of blocking
       the sale. form.submit() fires no submit event, so this cannot loop. */
    var checkoutGiftCheck = false;
    function drawerGiftsMissing() {
      var state = readCartStateFromDOM();
      var required = requiredGiftQuantities(state.watchCount);
      return Object.keys(required).some(function(id) {
        var have = (state.giftsByVariant[id] || []).reduce(function(total, line) { return total + Number(line.qty || 0); }, 0);
        return have < required[id];
      });
    }
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form.matches('.cw-cart-drawer__checkout-form')) return;
      if (cartMutating || syncing || checkoutGiftCheck) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!drawerGiftsMissing()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutGiftCheck = true;
      setCartBusy(true);
      var went = false;
      function goToCheckout() {
        if (went) return;
        went = true;
        var current = document.querySelector('.cw-cart-drawer__checkout-form') || form;
        var field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'checkout';
        current.appendChild(field);
        current.submit();
      }
      var timer = window.setTimeout(goToCheckout, 5000);
      syncGifts(null, true)
        .catch(function() {})
        .then(function() { window.clearTimeout(timer); goToCheckout(); });
    }, true);
    /* A page restored by the back button must be able to check out again. */
    window.addEventListener('pageshow', function() { checkoutGiftCheck = false; });

    /* On load, reconcile gifts from the rendered drawer DOM only, NO /cart.js.
       The page is already server-rendered with the real cart, so this issues a
       request ONLY when the markup shows a genuine gift discrepancy (rare),
       which removes the per-page-load /cart.js that was feeding the 429s. */
    function cleanupGiftsOnLoad() {
      initOfferCarousel();
      initPairCarousel();
      scheduleProtectionCheck();
      reconcileGiftsFromDOM(false).catch(function() {});
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cleanupGiftsOnLoad);
    } else {
      cleanupGiftsOnLoad();
    }

    /* Warm the images every cart shows (gifts, this product's thumbnail) once the
       page is idle, so the drawer paints them from cache right after add to cart. */
    function warmCartImages() {
      (window.CWCartConfig.warmImages || []).forEach(function(src) {
        if (!src) return;
        var img = new Image();
        img.decoding = 'async';
        img.src = src;
      });
    }
    function scheduleCartWarm() {
      if (window.requestIdleCallback) window.requestIdleCallback(warmCartImages, { timeout: 4000 });
      else setTimeout(warmCartImages, 1500);
    }
    if (document.readyState === 'complete') scheduleCartWarm();
    else window.addEventListener('load', scheduleCartWarm);
  })();
